/* Built In Imports */
import { useCallback, useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import RenderSections from '@landing_pages/GoY/Common/RenderSections';
import WrapLayout from '@Layout/WrapLayout';
import {
    acceptCookiesExists,
    getUtmParameters
} from '@utils/index.js';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData,
    filterBuildUrls,
    getLatestBuild
} from 'services/commonService';
import { fetchInPersonPageData, fetchProgInfo } from 'services/graceofyogaService';

/* Styles */
import globalStyles from '../../../../styles/goystyle';

/**
 *
 * @param root0
 * @param root0.region
 * @param root0.language
 * @param root0.footerData
 * @param root0.pageData
 * @param root0.page
 */
export default function GraceOfYoga({
  region,
  language,
  footerData,
  pageData,
  page
}) {
  // consoleLog('pageData', pageData.body[0].value);
  const [programData, setProgramData] = useState('');
  const [show, setShow] = useState(false);
  const [enableRegister, setEnableRegister] = useState('');
  const dataContent = pageData?.mainContent;
  const idArr = [];
  const [acceptCookies, setAcceptCookies] = useState(true);

  const setUtmParameters = useCallback(() => {
    let btnobj1 = document.querySelector('.btn-utm-param1');
    let btnobj2 = document.querySelector('.btn-utm-param2');
    let btnobj3 = document.querySelector('.btn-utm-param3');
    if (enableRegister != '') {
      let prgmfee = btnobj1.href;
      getUtmParameters(enableRegister, '.btn-utm-param1');
    }
    if (btnobj2 != null) {
      getUtmParameters(btnobj2.href, '.btn-utm-param2');
    }
    if (btnobj3 != null) {
      getUtmParameters(btnobj3.href, '.btn-utm-param3');
    }
  });
  useEffect(() => {
    // localData();
  }, [region, language]);

  useEffect(() => {
    let bannercontent = document.querySelector('#default_version');
    let bannerimage = document.querySelector('#default_version .desktop');
    let inpersontext = document.querySelector('ul.inperson');
    let inpersonlangoptn = document.querySelector('#inperson_lang');
    if (bannercontent != undefined) {
      bannercontent.style.display = 'none';
      bannerimage.style.display = 'none';
      inpersonlangoptn.style.display = 'none';
    }
    if (inpersontext != undefined) {
      inpersontext.style.display = 'none';
    }
    setUtmParameters();
    setAcceptCookies(acceptCookiesExists());
  }, [setUtmParameters]);

  /**
   *
   */
  
  const localData = async () => {
    let programData = await fetchProgInfo(region, language);

    setProgramData(programData);
  };

  useEffect(() => {
    if (document.querySelector('#goy_register1') != null) {
      document
        .querySelector('#goy_register1')
        .addEventListener('click', function () {
          window.dataLayer.push({ event: 'goy_register1' });
        });
    }
    if (document.querySelector('#goy_progdetails1') != null) {
      document
        .querySelector('#goy_progdetails1')
        .addEventListener('click', function () {
          window.dataLayer.push({ event: 'goy_progdetails1' });
        });
    }
    if (document.querySelector('#goy_progdetails2') != null) {
      document
        .querySelector('#goy_progdetails2 a')
        .addEventListener('click', function () {
          window.dataLayer.push({ event: 'goy_progdetails2' });
        });
    }
  }, []);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags}
        availableLocals={pageData?.availableLocales}
      />
      <Box as="section" className="page-wrap container-article" p="0">
        {pageData?.body?.length && pageData?.body[0]?.value.length
          ? pageData.body[0]?.value.map((section, i) => {
              return (
                <RenderSections
                  section={section}
                  region={region}
                  lang={language}
                  key={i}
                  csrData={programData}
                />
              );
            })
          : null}
      </Box>
      <style jsx global>
        {globalStyles}
      </style>
      <style jsx global>
          {` @media only screen and (max-width: 500px) {
            .contentContainer {
              padding-top: 0px;
              width: 100%;
              margin: 355px auto 0 auto;
              place-items: center;
              background-color: #030202;
            }
            .content {
                background-color: transparent;
            }
          }
        `}
      </style>
    </WrapLayout>
  );
}

export const getStaticPaths = async () => {
  let goyLandingPath = [
    '/in/en/grace-of-yoga-in-person',
    '/us/en/grace-of-yoga-in-person',
    '/global/en/grace-of-yoga-in-person',
];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
      let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
      goyLandingPath = filterBuildUrls(
          'landing_pages',
          'lvl0',
          '/grace-of-yoga-in-person',
          '',
          data
      );
  }
  return {
      paths: goyLandingPath,
      fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language }, req
}) => {
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchInPersonPageData(region, language, '',
    { preview, data: previewData });
  return {
    props: {
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'Exclusive',
      hideTopMenu: true,
      isPreview: preview ? true : false
    }
  };
};
